import { collection } from "@doitintl/models-types";
import { CustomerModelOrganizationModel } from "./Customer";

@collection("organizations")
export class OrganizationsModel extends CustomerModelOrganizationModel {}
